import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { history } from 'store';
import SweetAlert from 'react-bootstrap-sweetalert';
import IntlMessages from 'util/IntlMessages';
import ListRowImage from 'components/listRowImage';
import ListRowFavourite from 'components/ListRowFavourite';
import ListRowCheckbox from 'components/ListRowCheckbox';
import ListRowData from 'components/ListRowData';
import ListRowDropdown from 'components/ListRowDropdown';
import ProjectBusPriorityEdit from '../../projectBusPriorityMaintenance/projectBusPriorityEdit/index';
import {
    addFavouriteProjectBusPriority,
    onProjectBusPrioritySelect,
    onDeleteProjectBusPriority,
    onEditProjectBusPriority,
    selectProjectBusPriority,
} from 'actions/projectBusPriority';

const ProjectBusPriorityRow = (props) => {
    const dispatch = useDispatch();
    const [menuState, setMenuState] = useState(false);
    const [projectBusPriority, setProjectBusPriority] = useState(props.projectBusPriority);
    const [deleteProjectBusPriorityCheck, setDeleteProjectBusPriorityCheck] = useState(false);
    const width = useSelector(state => state.settings.width);
    // const { projectBusPriority } = props;

    useEffect(() => {
        setProjectBusPriority(props.projectBusPriority);
    }, [props]);

    const { name, starred } = projectBusPriority;
    const options = [
        'Edit',
        'Delete',
    ];

    const projectBusPriorityOptionToggle = () => {
        setMenuState(!menuState);
    };

    const deleteProjectBusPriority = (projectBusPriority) => {
        dispatch(onDeleteProjectBusPriority(projectBusPriority?.id));
    };

    const editProjectBusPriority = () => {
        setMenuState(false);
        dispatch(onEditProjectBusPriority(projectBusPriority));
    };

    return (
        <div className="contact-item">
            <ListRowCheckbox selected={projectBusPriority.selected} onClick={() => dispatch(onProjectBusPrioritySelect(projectBusPriority))} />
            <ListRowFavourite width={width} onClick={() => dispatch(addFavouriteProjectBusPriority(projectBusPriority))} starred={starred} />
            <ListRowImage width={width} data={projectBusPriority} />
            <ListRowData lineOne={name} />
            <ListRowDropdown
                menuState={menuState}
                toggle={projectBusPriorityOptionToggle}
                options={options}
                dropdownItems={options.map(option =>
                    <DropdownItem key={option} onClick={() => {
                        if (option === 'Edit') {
                            editProjectBusPriority();
                        } else if (option === 'Delete') {
                            setDeleteProjectBusPriorityCheck(true);
                        }
                    }
                    }>
                        {option}
                    </DropdownItem>,
                )}
            />
            <div>
                <ProjectBusPriorityEdit />
            </div>
            <SweetAlert show={deleteProjectBusPriorityCheck}
                warning
                showCancel
                confirmBtnText={<IntlMessages id="button.yesDeleteIt" />}
                cancelBtnText={<IntlMessages id="button.cancel" />}
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title={<span style={{ fontWeight: 'bold', color: 'grey', fontSize: '200%' }}><IntlMessages id="general.areYouSure" /></span>}
                onConfirm={() => {
                    deleteProjectBusPriority(projectBusPriority);
                    setDeleteProjectBusPriorityCheck(false);
                }}
                onCancel={() => {
                    setDeleteProjectBusPriorityCheck(false);
                }}
            >
                <IntlMessages id="projectBusPriority.deleteProjectBusPriority" />
            </SweetAlert>
        </div>
    );
};

export default ProjectBusPriorityRow;


// WEBPACK FOOTER //
// ./components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js